import { Field } from 'formik'
import TextInput from '../shared/TextInput'
import ReactSignatureCanvas from 'react-signature-canvas'
import { sequenceTableTemplate } from '../utils/squenceTableNo'
import {
  MdCheckBox,
  MdFormatListBulletedAdd,
  MdOutlineTextFields
} from 'react-icons/md'
import { BsTextareaT } from 'react-icons/bs'
import { CiCalendarDate, CiClock2 } from 'react-icons/ci'
import { FaEraser, FaHeading, FaImage, FaSignature } from 'react-icons/fa'
import { GiEmptyChessboard } from 'react-icons/gi'
import { TbBorderSides } from 'react-icons/tb'
import { InputText } from 'primereact/inputtext'
import { useEffect, useRef } from 'react'

export const formTypes = [
  { label: 'Labs', value: 'lab' },
  { label: 'Radiology', value: 'radiology' },
  { label: 'Homecare', value: 'visit' },
  { label: 'General', value: 'general' },
  { label: 'Inpatient', value: 'inpatient' },
  { label: 'Outpatient', value: 'outpatient' }
]

export const formListTypes = [
  { label: 'Labs', value: 'labs' },
  { label: 'Radiology', value: 'radiology' },
  { label: 'Homecare', value: 'homecare' },
  { label: 'General', value: 'general' }
]

export const formListCategoriesTypes = [
  { label: 'Primary', value: 'primary' },
  { label: 'Secondary', value: 'secondary' }
]

export const formListSubCategoriesTypes = [
  { label: 'Header', value: 'header' },
  { label: 'Body', value: 'body' },
  { label: 'Footer', value: 'footer' }
]

export const formElementsTypes = t => [
  {
    label: t('Input'),
    value: 'input',
    Icon: <MdFormatListBulletedAdd size={18} className='me-1' />
  },
  {
    label: t('Textarea'),
    value: 'textarea',
    Icon: <BsTextareaT size={18} className='me-1' />
  },
  {
    label: t('Date'),
    value: 'date',
    Icon: <CiCalendarDate size={18} className='me-1' />
  },
  {
    label: t('Time'),
    value: 'time',
    Icon: <CiClock2 size={18} className='me-1' />
  },
  {
    label: t('Signature Pad'),
    value: 'signature',
    Icon: <FaSignature size={15} className='me-1' />
  },
  {
    label: t('Image'),
    value: 'image',
    Icon: <FaImage size={15} className='me-1' />
  },
  {
    label: t('space'),
    value: 'Space',
    Icon: <GiEmptyChessboard size={15} className='me-1' />
  },
  {
    label: t('Bool'),
    value: 'bool',
    Icon: <MdCheckBox size={15} className='me-1' />
  },
  {
    label: t('Table-Border'),
    value: 'table-border',
    Icon: <TbBorderSides size={15} className='me-1' />
  },
  {
    label: t('Heading'),
    value: 'heading',
    Icon: <FaHeading size={15} className='me-1' />
  },
  {
    label: t('Text'),
    value: 'text',
    Icon: <MdOutlineTextFields size={15} className='me-1' />
  }
]

export const formElementsRangeOptions = [
  { label: 'Equals (==)', value: 'equal' },
  { label: 'Not Equals (!=)', value: 'notEqual' },
  { label: 'Greater Than (>)', value: 'greaterThan' },
  { label: 'Less Than (<)', value: 'lessThan' },
  { label: 'Greater Than or Equal (>=)', value: 'greaterOrEqual' },
  { label: 'Less Than or Equal (<=)', value: 'lessOrEqual' }
]

export const formElementsUnitsOptions = [
  { label: 'kg', value: 'kg' },
  { label: 'g', value: 'g' },
  { label: 'Other', value: 'other' }
]

export const formElementsRequiredOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
]

export const formatFormsListOptionTypes = (res = []) => {
  return res?.map(data => {
    return {
      label: data?.name_en,
      value: data?.id,
      data
    }
  })
}

export const formatFormsCategoriesOptionTypes = (res = []) => {
  return res?.map(data => {
    return {
      label: data?.name_en,
      value: data?.id,
      data
    }
  })
}

export const formatedElementsData = (
  formResponse,
  selectedSubCategoryId,
  setFormFields
) => {
  const formElements = {
    formHeader: [],
    formBody: [],
    formFooter: [],
    subCategories: []
  }
  if (formResponse?.data) {
    formResponse?.data?.subcategories?.forEach(subcategory => {
      if (subcategory?.elements && subcategory?.id == selectedSubCategoryId) {
        const elementData = {
          type: subcategory.type,
          name_en: subcategory.name_en,
          name_ar: subcategory.name_ar,
          subcategoryId: subcategory?.id,
          elements: [...subcategory.elements]
        }
        // Push the elementData to the appropriate array based on the type
        switch (subcategory.type) {
          case 'header':
            formElements.formHeader.push(elementData)
            break
          case 'body':
            formElements.formBody.push(elementData)
            break
          case 'footer':
            formElements.formFooter.push(elementData)
            break
          default:
            break
        }
      }
    })
    if (!formElements?.formBody?.length) formElements.formBody = []
    if (!formElements?.formHeader?.length) formElements.formHeader = []
    if (!formElements?.formFooter?.length) formElements.formFooter = []
    setFormFields(formElements)
  } else {
    setFormFields(formElements)
  }
}

export const renderPreviewFields = (index, field) => {
  switch (field.type) {
    case 'input':
      return (
        <TextInput
          key={index}
          useFormik={false}
          value={field?.value}
          label={field?.name_en}
          type='text'
          placeholder={field.name_en || 'Enter text'}
        />
      )
    case 'date':
      return (
        <TextInput
          key={index}
          useFormik={false}
          value={field?.value}
          label={field?.name_en}
          type='date'
          placeholder={field.name_en || 'Enter date'}
        />
      )
    case 'time':
      return (
        <TextInput
          key={index}
          useFormik={false}
          value={field?.value}
          label={field?.name_en}
          type='time'
          placeholder={field.name_en || 'Enter time'}
        />
      )
    case 'textarea':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <label className='input-label'>{field.name_en}</label>
          <textarea
            value={field?.value}
            rows='5'
            placeholder={field.name_en || 'Enter text'}
            className='input-field textarea-200px'
          />
        </div>
      )
    case 'bool':
      return (
        <div key={index} className='flex items-center gap-1 w-full mb-3'>
          <label className='input-label'>{field.name_en || 'Check'}</label>
          <input
            value={field?.value}
            className='w-[16px] h-[16px] mb-1 rounded ms-2'
            type='checkbox'
          />
        </div>
      )
    case 'heading':
      return (
        <h1 key={index} className='mt-4 mb-2 text-16-gray !font-semibold'>
          {field.name_en || ''}
        </h1>
      )
    case 'text':
      return (
        <h1 key={index} className='mt-4 mb-2 text-12-gray'>
          {field.name_en || ''}
        </h1>
      )
    case 'space':
      return (
        <div key={index} style={{ margin: '20px 0' }}>
          <p className='text-14-gray'> {field.name_en || 'Space'}</p>
        </div>
      )
    case 'table-border':
      return (
        <div
          key={index}
          style={{
            border: '1px solid black',
            padding: '10px',
            marginBottom: '15px',
            borderRadius: '5px'
          }}
        >
          {field.name_en || 'Table Border Content'}
        </div>
      )
    case 'image':
    case 'signature':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <label className='input-label'>{field.name_en}</label>
          <div className='border border-gray-300 rounded-lg my-2'>
            <img
              src={field?.value}
              alt='img'
              className='h-[200px] rounded w-full'
            />
          </div>
        </div>
      )
    default:
      return null
  }
}

export const renderFormSubCategoryRows = (formData, renderFields) => {
  if (!formData) return false
  const match = formData?.name_en?.match(/Col(\d+)/)
  const columnCount = match ? parseInt(match[1], 10) : 1
  const colSpan = 12 / columnCount

  const rows = []
  let currentRow = []
  let currentRowWidth = 0

  formData?.elements?.forEach(element => {
    const elementColSpan = element.type === 'heading' ? 12 : colSpan

    if (currentRowWidth + elementColSpan > 12) {
      rows.push(currentRow)
      currentRow = []
      currentRowWidth = 0
    }
    currentRow.push({ ...element, colSpan: elementColSpan })
    currentRowWidth += elementColSpan
  })
  if (currentRow.length > 0) {
    rows.push(currentRow)
  }
  return rows.map((row, rowIndex) => (
    <div className='w-full grid grid-cols-12 gap-3' key={`row-${rowIndex}`}>
      {row.map((col, colIndex) => {
        const colSpan = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].includes(
          col.colSpan
        )
          ? col.colSpan
          : 12
        return (
          <div className={`mb-2 col-span-${colSpan}`} key={`col-${colIndex}`}>
            {renderFields(colIndex, col)}
          </div>
        )
      })}
    </div>
  ))
}

export const formatedGeneralElementsData = (formResponse, setFormFields) => {
  const formElements = {
    formHeader: [],
    formBody: [],
    formFooter: [],
    subCategories: []
  }
  if (formResponse?.data) {
    formResponse?.data?.subcategories?.forEach(subcategory => {
      if (subcategory?.elements) {
        const elementData = {
          type: subcategory.type,
          name_en: subcategory.name_en,
          name_ar: subcategory.name_ar,
          subcategoryId: subcategory?.id,
          elements: [...subcategory.elements]
        }
        switch (subcategory.type) {
          case 'header':
            formElements.formHeader.push(elementData)
            break
          case 'body':
            formElements.formBody.push(elementData)
            break
          case 'footer':
            formElements.formFooter.push(elementData)
            break
          default:
            break
        }
      }
    })
    if (!formElements?.formBody?.length) formElements.formBody = []
    if (!formElements?.formHeader?.length) formElements.formHeader = []
    if (!formElements?.formFooter?.length) formElements.formFooter = []
    setFormFields(formElements)
  } else {
    setFormFields(formElements)
  }
}

export const renderFormFields = (index, field) => {
  switch (field.type) {
    case 'input':
      return (
        <Field name={`${field.id}`}>
          {({ field: formikField }) => (
            <TextInput
              key={index}
              useFormik={false}
              label={field?.name_en}
              type='text'
              value={formikField?.value}
              placeholder={field.name_en || 'Enter text'}
              required={field?.is_required}
              {...formikField}
            />
          )}
        </Field>
      )
    case 'date':
      return (
        <Field name={`${field.id}`}>
          {({ field: formikField }) => (
            <TextInput
              key={index}
              useFormik={false}
              label={field?.name_en}
              type='date'
              value={formikField?.value}
              placeholder={field.name_en || 'Enter date'}
              required={field?.is_required}
              {...formikField}
            />
          )}
        </Field>
      )
    case 'time':
      return (
        <Field name={`${field.id}`}>
          {({ field: formikField }) => (
            <TextInput
              key={index}
              useFormik={false}
              label={field?.name_en}
              required={field?.is_required}
              {...formikField}
              type='time'
              value={formikField?.value}
              placeholder={field.name_en || 'Enter time'}
            />
          )}
        </Field>
      )
    case 'textarea':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <label className='input-label'>{field.name_en}</label>
          <Field name={`${field.id}`}>
            {({ field: formikField }) => (
              <textarea
                value={formikField?.value}
                required={field?.is_required}
                {...formikField}
                rows='5'
                placeholder={field.name_en || 'Enter text'}
                className='input-field textarea-200px'
              />
            )}
          </Field>
        </div>
      )
    case 'bool':
      return (
        <div key={index} className='flex items-center gap-1 w-full mb-3'>
          <label className='input-label'>{field.name_en || 'Check'}</label>
          <Field name={`${field.id}`} type='checkbox'>
            {({ field: formikField }) => (
              <input
                value={formikField?.value}
                {...formikField}
                className='w-[16px] h-[16px] mb-1 rounded ms-2'
                type='checkbox'
              />
            )}
          </Field>
        </div>
      )
    case 'heading':
      return (
        <h1 key={index} className='mt-4 mb-2 text-16-gray !font-semibold'>
          {field.name_en || ''}
        </h1>
      )
    case 'text':
      return (
        <p key={index} className='mt-4 mb-2 text-14-gray !font-normal'>
          {field.name_en || ''}
        </p>
      )
    case 'space':
      return (
        <div key={index} style={{ margin: '20px 0' }}>
          <p className='text-14-gray'></p>
        </div>
      )
    case 'table-border':
      return (
        <div
          key={index}
          style={{
            border: '1px solid black',
            padding: '10px',
            marginBottom: '15px'
          }}
        >
          {field.name_en || 'Table Border Content'}
        </div>
      )
    case 'image':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <label className='input-label'>{field.name_en}</label>
          {typeof field?.value === 'string' &&
          field.value.startsWith('data:image') ? (
            <img
              src={field.value}
              alt='Uploaded Preview'
              className='w-full h-[300px] rounded-md mb-2 border'
            />
          ) : (
            <Field name={`${field.id}`}>
              {({ field: formikField, meta }) => (
                <input
                  type='file'
                  accept='image/*'
                  className='input-field h-40'
                  placeholder={field.name_en || 'Add Image'}
                  onChange={event => {
                    const file = event.target.files[0]
                    if (file) {
                      const reader = new FileReader()
                      reader.onloadend = () => {
                        formikField.onChange({
                          target: {
                            name: formikField.name,
                            value: reader.result
                          }
                        })
                      }
                      reader.readAsDataURL(file)
                    }
                  }}
                />
              )}
            </Field>
          )}
        </div>
      )
    case 'signature':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <label className='input-label'>{field.name_en}</label>
          <Field name={`${field.id}`}>
            {({ field: formikField, form }) => {
              const sigCanvasRef = useRef(null)

              // Load existing value (if any) into canvas
              useEffect(() => {
                if (
                  formikField.value &&
                  typeof formikField.value === 'string' &&
                  formikField.value.startsWith('data:image') &&
                  sigCanvasRef.current
                ) {
                  sigCanvasRef.current.fromDataURL(formikField.value)
                }
              }, [formikField.value])

              return (
                <div>
                  <ReactSignatureCanvas
                    ref={sigCanvasRef}
                    penColor='black'
                    canvasProps={{
                      className:
                        'h-[100px] mt-1 p-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                    }}
                    onEnd={() => {
                      const signatureData = sigCanvasRef.current.toDataURL()
                      formikField.onChange({
                        target: { name: `${field.id}`, value: signatureData }
                      })
                    }}
                  />
                  <div className='mt-2 flex space-x-2'>
                    <button
                      type='button'
                      className='text-sm bg-gray-200 px-3 py-1 rounded'
                      onClick={() => {
                        sigCanvasRef.current.clear()
                        formikField.onChange({
                          target: { name: `${field.id}`, value: '' }
                        })
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              )
            }}
          </Field>
        </div>
      )
    default:
      return null
  }
}

export const viewFormEntriesTableColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' }
  },
  { header: t('Created AT'), field: 'created_at' },
  { header: t('Patient Name'), field: 'full_name' },
  { header: t('Beneficiary Type'), field: 'beneficiary_type' },
  { header: t('MRN'), field: 'file_no' },
  { header: t('Nationality'), field: 'nationality' }
]

export const renderFormFieldsNew = (
  index,
  field,
  parentIndex,
  setInitializeRowsData
) => {
  const handleFieldChange = e => {
    const { value } = e?.target
    setInitializeRowsData(prev => {
      const newData = [...prev]
      const targetRow = { ...newData[parentIndex] }
      targetRow.formElements[index].value = value
      newData[parentIndex] = targetRow
      return newData
    })
  }
  const handleLabelValChange = e => {
    const { value } = e?.target
    setInitializeRowsData(prev => {
      const newData = [...prev]
      const targetRow = { ...newData[parentIndex] }
      targetRow.formElements[index].name_en = value
      newData[parentIndex] = targetRow
      return newData
    })
  }

  const handleImageChange = value => {
    setInitializeRowsData(prev => {
      const newData = [...prev]
      const targetRow = { ...newData[parentIndex] }
      targetRow.formElements[index].value = value
      newData[parentIndex] = targetRow
      return newData
    })
  }
  const handleClearSignature = value => {
    setInitializeRowsData(prev => {
      const newData = [...prev]
      const targetRow = { ...newData[parentIndex] }
      targetRow.formElements[index].value = ''
      newData[parentIndex] = targetRow
      return newData
    })
  }
  switch (field.type) {
    case 'input':
      return (
        <ElementPreviewTextField
          key={index}
          value={field?.value}
          label={field?.name_en}
          type='text'
          placeholder={field.name_en || 'Enter text'}
          onChange={handleFieldChange}
          hanldeLabelValueChange={handleLabelValChange}
        />
      )
    case 'date':
      return (
        <ElementPreviewTextField
          key={index}
          value={field?.value}
          label={field?.name_en}
          type='date'
          placeholder={field.name_en || 'Enter date'}
          onChange={handleFieldChange}
          hanldeLabelValueChange={handleLabelValChange}
        />
      )
    case 'time':
      return (
        <ElementPreviewTextField
          key={index}
          value={field?.value}
          label={field?.name_en}
          type='time'
          placeholder={field.name_en || 'Enter time'}
          onChange={handleFieldChange}
          hanldeLabelValueChange={handleLabelValChange}
        />
      )
    case 'textarea':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <input
            value={field?.name_en}
            onChange={handleLabelValChange}
            className='form-creation-label-input input-label'
          />
          <textarea
            value={field?.value}
            rows='3'
            placeholder={field.name_en || 'Enter text'}
            className='input-field textarea-100px'
            onChange={handleFieldChange}
          />
        </div>
      )
    case 'bool':
      return (
        <div key={index} className='flex items-start flex-col w-full mb-3'>
          <input
            value={field?.name_en}
            onChange={handleLabelValChange}
            className='form-creation-label-input input-label'
          />
          <input
            value={field?.value}
            className='w-[16px] h-[16px] mb-1 rounded ms-1 mt-2'
            type='checkbox'
            onChange={handleFieldChange}
          />
        </div>
      )
    case 'heading':
      return (
        <h1 key={index} className='mb-2 text-16-gray !font-semibold'>
          <input
            value={field?.name_en}
            onChange={handleLabelValChange}
            className='form-creation-label-input text-16-gray !font-semibold'
          />
        </h1>
      )
    case 'text':
      return (
        <h1 key={index} className='mb-2 text-12-gray'>
          <input
            value={field?.name_en}
            onChange={handleLabelValChange}
            className='form-creation-label-input !text-12-gray'
          />
        </h1>
      )
    case 'space':
      return (
        <div key={index} style={{ margin: '20px 0' }}>
          <p className='text-14-gray'> {field.name_en || 'Space'}</p>
        </div>
      )
    case 'table-border':
      return (
        <div
          key={index}
          style={{
            border: '1px solid black',
            marginBottom: '15px',
            borderRadius: '5px'
          }}
          className='p-1'
        >
          <input
            value={field.name_en}
            onChange={handleLabelValChange}
            className='form-creation-label-input !text-12-gray'
          />
        </div>
      )
    case 'image':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <ImageField
            key={index}
            field={field}
            onImageChange={handleImageChange}
            handleLabelValChange={handleLabelValChange}
          />
        </div>
      )
    case 'signature':
      return (
        <div className='flex flex-col gap-1 w-full mb-3' key={index}>
          <RenderSignaturePad
            key={index}
            field={field}
            handleLabelValChange={handleLabelValChange}
            onImageChange={handleImageChange}
            handleClearSignature={handleClearSignature}
          />
        </div>
      )
    default:
      return null
  }
}

const ElementPreviewTextField = ({
  placeholder = '',
  label = '',
  name = '',
  className = '',
  iconClassName = '',
  value = '',
  type = 'text',
  parentClass = '',
  handleChange = () => {},
  hanldeLabelValueChange = () => {},
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <input
          value={label}
          onChange={hanldeLabelValueChange}
          className='form-creation-label-input input-label'
        />
      )}
      <InputText
        id={name}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        autoComplete='off'
        onChange={handleChange}
        {...(type === 'number' ? { min: 0 } : {})}
        {...props}
        className={`input-field ${className}`}
      />
    </div>
  )
}

const ImageField = ({ field, index, onImageChange, handleLabelValChange }) => {
  return (
    <div className='flex flex-col gap-1 w-full mb-3' key={index}>
      <input
        value={field.name_en}
        onChange={handleLabelValChange}
        className='form-creation-label-input'
      />
      <div className='border border-gray-300 rounded-lg my-2'>
        <img
          src={field?.value}
          alt='img'
          className='h-full max-h-[300px] rounded w-full'
        />
      </div>
    </div>
  )
}

const RenderSignaturePad = ({
  field,
  index,
  handleLabelValChange,
  onImageChange,
  handleClearSignature
}) => {
  const sigCanvasRef = useRef()

  useEffect(() => {
    if (field.value && sigCanvasRef.current) {
      sigCanvasRef.current.fromDataURL(field.value)
    }
  }, [])

  useEffect(() => {
    if (!field?.value) {
      sigCanvasRef.current.clear()
    }
  }, [field?.value])
  return (
    <div className='flex flex-col gap-1 w-full mb-3' key={index}>
      <input
        value={field.name_en}
        onChange={handleLabelValChange}
        className='form-creation-label-input'
      />
      <div className='relative'>
        <ReactSignatureCanvas
          ref={sigCanvasRef}
          penColor='black'
          canvasProps={{
            className:
              'h-[100px] mt-1 p-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm relative'
          }}
          onEnd={() => {
            if (sigCanvasRef.current) {
              const signatureData = sigCanvasRef.current.toDataURL()
              onImageChange(signatureData)
            }
          }}
        />
        <FaEraser
          size={20}
          className='absolute text-red-500 top-[-5px] cursor-pointer right-[-5px]'
          onClick={handleClearSignature}
        />
      </div>
    </div>
  )
}

export const formListTableColumns = t => [
  {
    body: sequenceTableTemplate,
    header: t('No'),
    style: { width: '3rem' }
  },
  {
    header: t('Type'),
    field: 'type'
  },
  {
    header: t('name_en'),
    field: 'name_en'
  },
  {
    header: t('name_ar'),
    field: 'name_ar'
  }
]

export const formDetailsList = (detail, t) => {
  return [
    {
      label: t('Type'),
      text: detail?.type || '--'
    },
    {
      label: t('name_en'),
      text: detail?.name_en || '--'
    },
    {
      label: t('name_ar'),
      text: detail?.name_ar || '--'
    }
  ]
}
